/**  消息管理 */
export const msg = [
  {
    name: 'getUnreadMessageCountList', // 未读消息列表
    isMock: false,
  },
  {
    name: 'getUnreadTotalCount', // 获取未读消息总数
    isMock: false,
  },
  {
    name: 'readMessage', // 阅读单个类型消息
    isMock: false,
  },
  {
    name: 'readAllMessage', // 阅读所有消息
    isMock: false,
  },
  {
    name: 'msgList', // 阅读单个类型消息
    isMock: false,
  },
  {
    name: 'setShieldingStatus', // 屏蔽/取消屏蔽消息
    isMock: false,
  },
]
